import type { components } from '../../.types/tea-authoring-svc';

export type CreateDocumentBody = components['schemas']['DocumentCreateBody'];
export type MetaProperty = CreateDocumentBody['data']['attributes']['meta'];

export async function createDocument(
  baseUrl: string,
  accessToken: string,
  documentUuid: string,
  referrer: string,
  body: CreateDocumentBody,
): Promise<{ error: null | Error }> {
  let error = null;

  try {
    const response = await fetch(`${baseUrl}/documents/${documentUuid}`, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        Authorization: `Bearer ${accessToken}`,
        Referer: referrer,
      },
    });

    if (!response.ok) {
      return {
        error: new Error(
          `Failed to save document: ${response.status} - ${response.statusText}`,
        ),
      };
    }
  } catch (err) {
    console.error('Error creating document', error);
    error = err as Error;
  }

  return { error };
}
